import { useFlagActions, useFlags } from 'utils/hooks/flags';
import { Badge } from '@/ui/design-system/components/ui/badge';
import { Pencil } from 'lucide-react';

function HashtagBadge({
    hashtag,
    flagId,
    flagData,
    enableFlagging = true,
    maxWidthClass = 'max-w-[180px]',
    translationLanguage = null,
}) {
    const { flagItem, unflagItem } = useFlagActions();
    const { data: flags } = useFlags();
    const resolvedFlagId = flagId;
    const isFlagged = (flags || []).some(
        (currentFlagId) => resolvedFlagId === currentFlagId,
    );

    const handleFlagClick = (e) => {
        e.stopPropagation();
        (isFlagged ? unflagItem : flagItem)({
            flagId: resolvedFlagId,
            data: flagData,
        });
    };

    return (
        <Badge
            className={`min-w-0 ${maxWidthClass} transition-colors [&:has(button:hover)]:bg-primary [&:has(button:hover)]:text-primary-foreground ${
                isFlagged ? 'opacity-50' : ''
            } ${translationLanguage ? 'bg-accent italic' : ''}`}
            variant="secondary"
        >
            <span className="truncate" lang={translationLanguage}>
                {hashtag}
            </span>
            {enableFlagging && (
                <button
                    onClick={handleFlagClick}
                    className="p-0 bg-transparent border-0 cursor-pointer group/flag"
                    aria-label={
                        isFlagged
                            ? 'Remove flag'
                            : 'Flag as miscategorized or irrelevant'
                    }
                >
                    <Pencil className="size-3 text-muted-foreground group-hover/flag:text-primary-foreground" />
                </button>
            )}
        </Badge>
    );
}

export default HashtagBadge;
